/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestsRefreshTokenDtoRefreshTokenDto } from '../../models/requests-refresh-token-dto-refresh-token-dto';

export interface UserClientControllerRefreshV1$Params {
      body: RequestsRefreshTokenDtoRefreshTokenDto
}

export function userClientControllerRefreshV1(http: HttpClient, rootUrl: string, params: UserClientControllerRefreshV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, userClientControllerRefreshV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      }>;
    })
  );
}

userClientControllerRefreshV1.PATH = '/api/v1/users/client/refresh';
